import { createContext } from 'react';

import type { useStaticReferrals } from '~/routes/subscribe/$subscriberId/_components/v2/hooks/useStaticReferrals';

type StaticReferrals = ReturnType<typeof useStaticReferrals>;

/**
 * Logic layer for the referrals surface on the General tab — the `ReferralsElement` (referral
 * summary, rewards progress, share link). Thin wrapper over `useStaticReferrals`; exposes the
 * referral data + the copy-link handler via context, plus a `showReferrals` gate. Holds no UI;
 * the colocated `ReferralsSection` child renders from it.
 */
export type ReferralsContextType = {
  /** `has_referral_program && !isSubscriptionInvalid` — whether the referrals block renders. */
  showReferrals: boolean;
  isLoadingReferrals: StaticReferrals['isLoading'];
  referrals: StaticReferrals['referrals'];
  referralCount: StaticReferrals['referralCount'];
  referralLink: StaticReferrals['referralLink'];
  rewards: StaticReferrals['rewards'];
  onClickCopyReferralLink: StaticReferrals['onClickCopy'];
};

export const ReferralsContext = createContext<ReferralsContextType | undefined>(undefined);
ReferralsContext.displayName = 'ReferralsContext';
